import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';
import { Tabs, Tab } from 'react-bootstrap';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import { Modal } from 'react-bootstrap';

// Tabs
import ScheduleGradeFleetTab from './Elements/ScheduleGradeFleetTab';
import ScheduleGradeEditTab from './Elements/ScheduleGradeEditTab';
import ScheduleGradeInitialsTab from './Elements/ScheduleGradeInitialsTab';
import ScheduleGradeEquipmentChiefTab from './Elements/ScheduleGradeEquipmentChiefTab';
import ScheduleGradeTrainingsTab from './Elements/ScheduleGradeTrainingsTab';
import ScheduleGradeRequestsTab from './Elements/ScheduleGradeRequestsTab';
import ScheduleGradeStaffRemainingTab from './Elements/ScheduleGradeStaffRemainingTab';
import getLocale from '../../i18n/getLocale';

class ScheduleGradesEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      updated: 0,
      key: 1,
      schedule_grade: {},
      schedule: {},
      aircraft_model: {},
      grade_size: 0,
      grade_alternate: {},
      grade: {},
      grade_alternate_original: {},
      grade_original: {},
      grade_extra_main: {},
      aircrafts_available: {},
      staffs_list: null,
      aircrafts_remaining: {},
      bases: {},
      aircrafts_list: {},
      bases_active_list: {},
      schedule_days: {},
      types_list: [],
      staffs_by_id: {},
      initials_colors: {},
      initials: {},
      schedule_grade_initials: {},
      schedule_grade_initials_secondary: {},
      schedule_grade_initials_vacation: {},
      chiefs: {},
      remaining_staffs: {},
      remaining_staffs_list: {},
      edit_mode: false,
      modal_alert: false,
      modal_aircraft_alert: false,
      modal_personal_alert: false,
      alerts: {},
      alerts_aircraft: {},
      schedule_used_regime_list: {},
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.locale = getLocale();

    this.loadData = this.loadData.bind(this);
    this.updateData = this.updateData.bind(this);
    this.updateDataEditMode = this.updateDataEditMode.bind(this);
    this.generateAlerts = this.generateAlerts.bind(this);
    this.closeModalAlert = this.closeModalAlert.bind(this);
    this.closeModalAircraftAlert = this.closeModalAircraftAlert.bind(this);
    this.closeModalPersonalAlert = this.closeModalPersonalAlert.bind(this);
    this.generateAlertsPdf = this.generateAlertsPdf.bind(this);
    this.toggleEditMode = this.toggleEditMode.bind(this);
    this.resetGrade = this.resetGrade.bind(this);
    this.saveGrade = this.saveGrade.bind(this);
    this.generatePersonalAlerts = this.generatePersonalAlerts.bind(this);
    this.generateAircraftAlerts = this.generateAircraftAlerts.bind(this);
  }

  // Handlers
  handleNavTab(state, key) {
    var change = {};
    if(this.state.edit_mode) {
      this.setState({overlay: {message: this.locale.GradesDeEscala.EditarGradeDeEscala.naoEPossivelMudarAbaComEdicaoEmAberto, type: 'warning', status: 'open'}});
    } else {
      change[state] = key;
      this.setState(change);
      this.setState({overlay: {message: '', type: '', status: ''}});
    }
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  //LM
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  // Fecha modal
  closeModalAlert(event){
    this.setState({modal_alert: false, alerts: {}});
  }

  // Fecha modal
  closeModalAircraftAlert(event){
    this.setState({modal_aircraft_alert: false, alerts_aircraft: {}});
  }
  // Fecha modal
  closeModalPersonalAlert(event){
    this.setState({modal_personal_alert: false, personal_alerts: {}});
  }

  // Toggle de modo de edição
  toggleEditMode(){
    if (this.state.edit_mode) {
      this.setState({edit_mode: false});
    } else {
      this.setState({edit_mode: true});
    }
  }

  // gero os dados do modal de alertas da grade
  generateAlerts (schedule_id) {
    var self = this;
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/gerar/alertas/' + schedule_id + '/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({alerts: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.setState({modal_alert: true});
      })
    });
  }

  // gero os dados do modal de alertas da grade
  generatePersonalAlerts (schedule_grade_aircraft_staff_id) {
    var self = this;
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/gerar/alerta/pessoal/' + schedule_grade_aircraft_staff_id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({alerts: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.setState({modal_personal_alert: true});
      })
    });
  }

  // gero os dados do modal de alertas da grade
  generateAircraftAlerts (schedule_grade_aircraft_id) {
    var self = this;
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/gerar/alerta/aeronave/' + schedule_grade_aircraft_id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({alerts_aircraft: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.setState({modal_aircraft_alert: true});
      })
    });
  }

  updateData (responseJson) {
    this.setState({updated: 1, show_select: 0}, this.loadData(responseJson));
  }

  reorderGrade(grade) {
    // reordenamos a escala regular por base > contrato > linha > prioridade
    var reordered_grade = {};
    Object.keys(grade).map(function(k) {
      var line = grade[k];

      if(typeof reordered_grade[parseInt(line.base_id)] === 'undefined') reordered_grade[parseInt(line.base_id)] = {};
      if(typeof reordered_grade[parseInt(line.base_id)][parseInt(line.contract_id)] === 'undefined') reordered_grade[parseInt(line.base_id)][parseInt(line.contract_id)] = {};

      if(typeof reordered_grade[parseInt(line.base_id)][parseInt(line.contract_id)][parseInt(line.line)] === 'undefined') reordered_grade[parseInt(line.base_id)][parseInt(line.contract_id)][parseInt(line.line)] = {};

      if(typeof reordered_grade[parseInt(line.base_id)][parseInt(line.contract_id)][parseInt(line.line)][parseInt(line.priority)] === 'undefined') reordered_grade[parseInt(line.base_id)][parseInt(line.contract_id)][parseInt(line.line)][parseInt(line.priority)] = [];

      reordered_grade[parseInt(line.base_id)][parseInt(line.contract_id)][parseInt(line.line)][parseInt(line.priority)].push(line);
    })

    var new_grade = [];
    var color = 0;
    Object.keys(reordered_grade).map(function(base_id) {
      var contracts = reordered_grade[base_id];
      Object.keys(contracts).map(function(contract_id) {
        var lines = contracts[contract_id];
        if(color === 0) { color = 1; } else { color = 0; }
        Object.keys(lines).map(function(line) {
          var priorities = lines[line];
          Object.keys(priorities).map(function(priority) {
            var items = priorities[priority];
            Object.keys(items).map(function(k) {
              var item = items[k];
              item.color = color
              new_grade.push(item);
            })
          })
        })
      })
    })

    return(new_grade);
  }

  updateDataEditMode (grade) {
    this.setState({updated: 1, show_select: 0, grade_alternate: {...grade.grade_alternate}, grade: this.reorderGrade([...grade.grade])});
    this.setState({overlay: {message: '', type: '', status: 'closed'}});
  }

  resetGrade () {
    if(window.confirm(this.locale.GradesDeEscala.EditarGradeDeEscala.descartarAlteracoes)) {
      this.setState({overlay: {message: '', type: '', status: 'open'}});
      this.toggleEditMode();
      this.updateData();
    }
  }

  saveGrade () {
    var self = this;
    if(window.confirm(this.locale.GradesDeEscala.EditarGradeDeEscala.salvarAlteracoes)) {
      this.handleAlert('', '', 'open');
      var datasave = {
        grade: this.state.grade,
        grade_alternate: this.state.grade_alternate,
        id: self.props.match.params.id,
      };
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/escala/grade/edicao/salvar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.toggleEditMode();
            self.updateData(responseJson);
          } else {
            self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  loadData (event) {
    var self = this;
    var aircraft_model_id = 0;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/escala/grade/info/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/escalas');
        if (responseJson.data.schedule_grade) {
          aircraft_model_id = responseJson.data.schedule_grade.schedule.aircraft_model_id;
          self.setState({schedule_grade: responseJson.data.schedule_grade});
          self.setState({schedule: responseJson.data.schedule_grade.schedule});
          self.setState({aircraft_model: responseJson.data.schedule_grade.schedule.aircraft_model});
          self.setState({schedule_grade_initials: responseJson.data.schedule_grade_initials.data});
          self.setState({schedule_grade_initials_secondary: responseJson.data.schedule_grade_initials_secondary});
          self.setState({schedule_grade_initials_vacation: responseJson.data.schedule_grade_initials_vacation});
        }
        if (responseJson.status === 'success') {
          self.setState({staffs_by_id: responseJson.data.staffs_by_id});
          self.setState({schedule_used_regimes: responseJson.data.schedule_used_regimes});
          self.setState({schedule_used_regime_list: responseJson.data.schedule_used_regime_list});
          self.setState({staff_schedule_requests: responseJson.data.staff_schedule_requests});
          self.setState({schedule_days: responseJson.data.schedule_days});
          self.setState({schedule_staff_trainings: responseJson.data.schedule_staff_trainings.data});
          self.setState({grade_extra_main: responseJson.data.grade_alternate.data.extra_main});
          self.setState({grade: self.reorderGrade(responseJson.data.grade_alternate.data.main)});
          self.setState({grade_original: self.reorderGrade(responseJson.data.grade_alternate.data.main)});
          self.setState({grade_alternate: responseJson.data.grade_alternate.data});
          self.setState({grade_alternate_original: responseJson.data.grade_alternate.data});
          self.setState({aircrafts_available: responseJson.data.aircrafts_available.data});
          self.setState({aircrafts_list: responseJson.data.aircrafts_list.data});
          self.setState({aircrafts_remaining: responseJson.data.aircrafts_remaining.data});
          self.setState({bases: responseJson.data.bases.data});
          self.setState({bases_active_list: responseJson.data.bases_active_list.data});
          self.setState({staffs_list: responseJson.data.staffs_list.data});
          self.setState({types_list: responseJson.data.types_list.data});
          self.setState({initials_colors: responseJson.data.initials_colors.data});
          self.setState({initials: responseJson.data.initials.data});
          self.setState({chiefs: responseJson.data.chiefs.data});
          self.setState({remaining_staffs: responseJson.data.remaining_staffs.data});
          self.setState({remaining_staffs_list: responseJson.data.remaining_staffs_list.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (typeof event === 'undefined') {
          self.handleMessage();
        } else {
          self.handleAlert(event.message, event.status, 'open');
        }
      });
    });
  }


  generateAlertsPdf(schedule_grade_id) {
    var self = this;
    this.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/exportar/pdf/escala-grade/alertas/' + schedule_grade_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        window.open(config.get('cdn') + '/tmp/' + responseJson.data);
      })
    });
  }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={self.handleLoaded} />
  <Overlay overlay={self.state.overlay} handleAlert={self.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.GradesDeEscala.EditarGradeDeEscala.titulo} - {self.state.aircraft_model.model} - {self.state.schedule.name}</h3>
      <Link to={"/escala/editar/" + self.state.schedule.id} className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="btn-group button-inline pull-right">
        <Link to={"/escala/grade/alertas/" + self.props.match.params.id} className="btn btn-primary button-inline"><i className="fa fa-warning"></i> {this.locale.GradesDeEscala.EditarGradeDeEscala.botaoExibirAlertasDetalhados}</Link>
        <button onClick={() => { self.generateAlerts(self.state.schedule.id) }} className="btn btn-warning button-inline"><i className="fa fa-warning"></i> {this.locale.GradesDeEscala.EditarGradeDeEscala.botaoExibirAlertas}</button>
        <button className="btn btn-warning button-inline" onClick={() => { self.generateAlertsPdf(self.props.match.params.id) }}><i className="fa fa-fw fa-file-pdf-o"></i></button>
      </div>
      <div className="clearfix"></div>
      <hr/>
      <Tabs activeKey={self.state.key} onSelect={self.handleNavTab.bind(self, 'key')} id="controlled-tab-example">
        <Tab eventKey={1} title={this.locale.GradesDeEscala.EditarGradeDeEscala.tabEscala.tituloTab}>
          <ScheduleGradeEditTab schedule_id={self.state.schedule.id} schedule_grade_id={self.props.match.params.id} updateData={self.updateData} updated={self.state.updated} handleAlert={self.handleAlert} grade={self.state.grade} grade_alternate={self.state.grade_alternate} grade_extra_main={self.state.grade_extra_main} staffs_list={self.state.staffs_list} remaining_staffs_list={self.state.remaining_staffs_list} schedule_days={self.state.schedule_days} types_list={self.state.schedule_grade_initials} initials_colors={self.state.initials_colors} bases_list={self.state.basesbasesbases} schedule_used_regime_list={self.state.schedule_used_regime_list} schedule_used_regimes={self.state.schedule_used_regimes} bases_active_list={self.state.bases_active_list} aircrafts_list={self.state.aircrafts_list} schedule_grade_initials_secondary={self.state.schedule_grade_initials_secondary} edit_mode={self.state.edit_mode} toggleEditMode={self.toggleEditMode} updateDataEditMode={self.updateDataEditMode} generatePersonalAlerts={self.generatePersonalAlerts} generateAircraftAlerts={self.generateAircraftAlerts} staffs_by_id={self.state.staffs_by_id} resetGrade={self.resetGrade} saveGrade={self.saveGrade} />
        </Tab>
        <Tab eventKey={2} title={this.locale.GradesDeEscala.EditarGradeDeEscala.tabAdicionarAeronave.tituloTab}>
          <ScheduleGradeFleetTab schedule_id={self.state.schedule.id} schedule_grade_id={self.props.match.params.id}  updateData={self.updateData} updated={self.state.updated} handleAlert={self.handleAlert} aircrafts_available={self.state.aircrafts_available} aircrafts_remaining={self.state.aircrafts_remaining} bases={self.state.bases} edit_mode={self.state.edit_mode} toggleEditMode={self.toggleEditMode} />
        </Tab>
        <Tab eventKey={3} title={this.locale.GradesDeEscala.EditarGradeDeEscala.tabForaDaEscala.tituloTab}>
          <ScheduleGradeStaffRemainingTab date_finish={self.state.schedule.date_finish_str} date_start={self.state.schedule.date_start_str} schedule_id={self.state.schedule.id} schedule_grade_id={self.props.match.params.id}  updateData={self.updateData} updated={self.state.updated} handleAlert={self.handleAlert} remaining_staffs={self.state.remaining_staffs} schedule_grade_initials_secondary={self.state.schedule_grade_initials_secondary} schedule_grade_initials_vacation={self.state.schedule_grade_initials_vacation} types_list={self.state.types_list} edit_mode={self.state.edit_mode} toggleEditMode={self.toggleEditMode} />
        </Tab>
        <Tab eventKey={4} title={this.locale.GradesDeEscala.EditarGradeDeEscala.tabChefesDeEquipamento.tituloTab}>
          <ScheduleGradeEquipmentChiefTab date_finish={self.state.schedule.date_finish_str} date_start={self.state.schedule.date_start_str} schedule_id={self.state.schedule.id} schedule_grade_id={self.props.match.params.id}  updateData={self.updateData} updated={self.state.updated} handleAlert={self.handleAlert} chiefs={self.state.chiefs} types_list={self.state.types_list} edit_mode={self.state.edit_mode} toggleEditMode={self.toggleEditMode} />
        </Tab>
        <Tab eventKey={5} title={this.locale.GradesDeEscala.EditarGradeDeEscala.tabTreinamentos.tituloTab}>
          <ScheduleGradeTrainingsTab schedule_id={self.state.schedule.id} schedule_grade_id={self.props.match.params.id}  updateData={self.updateData} updated={self.state.updated} handleAlert={self.handleAlert} schedule_staff_trainings={self.state.schedule_staff_trainings} edit_mode={self.state.edit_mode} toggleEditMode={self.toggleEditMode} />
        </Tab>
        <Tab eventKey={6} title={this.locale.GradesDeEscala.EditarGradeDeEscala.tabSolicitacoes.tituloTab}>
          <ScheduleGradeRequestsTab schedule_id={self.state.schedule.id} schedule_grade_id={self.props.match.params.id}  updateData={self.updateData} updated={self.state.updated} handleAlert={self.handleAlert} staff_schedule_requests={self.state.staff_schedule_requests} edit_mode={self.state.edit_mode} toggleEditMode={self.toggleEditMode} />
        </Tab>
        <Tab eventKey={7} title={this.locale.GradesDeEscala.EditarGradeDeEscala.tabSiglas.tituloTab}>
          <ScheduleGradeInitialsTab schedule_id={self.state.schedule.id} schedule_grade_id={self.props.match.params.id} updateData={self.updateData} updated={self.state.updated} handleAlert={self.handleAlert} initials={self.state.initials} edit_mode={self.state.edit_mode} toggleEditMode={self.toggleEditMode} />
        </Tab>
      </Tabs>
    </div>
  </div>
  <Modal show={self.state.modal_aircraft_alert} aria-labelledby="contained-modal-alert-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">{this.locale.GradesDeEscala.EditarGradeDeEscala.tituloRevisao} {self.state.schedule_grade.revision} - {self.state.aircraft_model.model} - {self.state.schedule.name}</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={self.closeModalAircraftAlert}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <div>
        <table className="table table-bordered">
          <thead>
            <tr>
              <th className="col-md-1 text-center">Area responsavel</th>
              <th className="col-md-2 text-center">{this.locale.GradesDeEscala.EditarGradeDeEscala.tabelaAeronave.Aeronave}</th>
              <th className="col-md-1 text-center">Controlado</th>
              <th className="col-md-10 text-center">{this.locale.GradesDeEscala.EditarGradeDeEscala.tabelaAeronave.Alerta}</th>
            </tr>
          </thead>
          <tbody id="suppliers-certifications">
            {Object.keys(self.state.alerts_aircraft).map(function(k) {
              var alert = self.state.alerts_aircraft[k];
              return(
                <tr>
                  <td className={"text-center box-alert box-alert-" + alert.color}>{alert.sector}</td>
                  <td className={"text-center box-alert box-alert-" + alert.color}>{alert.aircraft}</td>
                  <td className={"text-center box-alert box-alert-" + alert.color}>{alert.controlled}</td>
                  <td className={"text-center box-alert box-alert-" + alert.color}><div dangerouslySetInnerHTML={{__html: alert.message}}></div></td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={self.closeModalAircraftAlert}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
  <Modal show={self.state.modal_personal_alert} aria-labelledby="contained-modal-alert-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">{this.locale.GradesDeEscala.EditarGradeDeEscala.tituloRevisao} {self.state.schedule_grade.revision} - {self.state.aircraft_model.model} - {self.state.schedule.name}</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={self.closeModalPersonalAlert}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
    {
      (typeof self.state.alerts.personal_alerts !== 'undefined') ?
      <div>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th className="col-md-1 text-center">{this.locale.GradesDeEscala.EditarGradeDeEscala.tabelaNome.NomeMatricula}</th>
            <th className="col-md-1 text-center">{this.locale.GradesDeEscala.EditarGradeDeEscala.tabelaNome.RegimeDeTrabalho}</th>
            <th className="col-md-1 text-center">{this.locale.GradesDeEscala.EditarGradeDeEscala.tabelaNome.NomeMatricula}</th>
            <th className="col-md-8 text-center">{this.locale.GradesDeEscala.EditarGradeDeEscala.tabelaNome.Alerta}</th>
          </tr>
        </thead>
        {Object.keys(self.state.alerts.personal_alerts).map(function(index_alert) {
          var alerts = self.state.alerts.personal_alerts[index_alert];
          var staff_data = index_alert.split('*');
          return(
            <tbody id="suppliers-certifications">
              {Object.keys(alerts).map(function(k) {
                var alert = alerts[k];
                if (alert.status === 'danger') {
                  return(
                    <tr>
                      <td className={"text-center box-alert box-alert-" + alert.color}>{staff_data[0]}</td>
                      <td className={"text-center box-alert box-alert-" + alert.color}>{alert.regime}</td>
                      <td className={"text-center box-alert box-alert-" + alert.color}>{alert.controlled}</td>
                      <td className={"text-center box-alert box-alert-" + alert.color}><div dangerouslySetInnerHTML={{__html: alert.message}}></div></td>
                    </tr>
                  );
                } else {
                  return(
                    ''
                  );
                }
              })}
            </tbody>
          );
        })}
        </table>
        </div>
      :
      ''
    }

    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={self.closeModalPersonalAlert}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
  <Modal show={self.state.modal_alert} aria-labelledby="contained-modal-alert-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">{this.locale.GradesDeEscala.EditarGradeDeEscala.tituloRevisao} {self.state.schedule_grade.revision} - {self.state.aircraft_model.model} - {self.state.schedule.name}</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={self.closeModalAlert}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
    {
      (typeof self.state.alerts.global_alerts !== 'undefined') ?
      <div>
        {Object.keys(self.state.alerts.global_alerts).map(function(k) {
          var alert = self.state.alerts.global_alerts[k];
          if (alert.status === 'danger') {
            return(
              <div className={"box-alert box-alert-" + alert.color}>
                <h4><strong>{alert.title}</strong></h4>
                  <div dangerouslySetInnerHTML={{__html: alert.message}}></div>
              </div>
            );
          } else {
            return(
              ''
            );
          }
        })}
        <hr/>
      </div>
      :
      ''
    }
    {
      (typeof self.state.alerts.personal_alerts !== 'undefined') ?
      <div>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th className="col-md-1 text-center">{this.locale.GradesDeEscala.EditarGradeDeEscala.tabelaNome.NomeMatricula}</th>
            <th className="col-md-8 text-center">{this.locale.GradesDeEscala.EditarGradeDeEscala.tabelaNome.Alerta}</th>
          </tr>
        </thead>
        {Object.keys(self.state.alerts.personal_alerts).map(function(index_alert) {
          var alerts = self.state.alerts.personal_alerts[index_alert];
          var staff_data = index_alert.split('*');
          return(
            <tbody id="suppliers-certifications">
              {Object.keys(alerts).map(function(k) {
                var alert = alerts[k];
                if (alert.status === 'danger') {
                  return(
                    <tr>
                      <td className={"text-center box-alert box-alert-" + alert.color}>{staff_data[0]}</td>
                      <td className={"text-center box-alert box-alert-" + alert.color}><div dangerouslySetInnerHTML={{__html: alert.message}}></div></td>
                    </tr>
                  );
                } else {
                  return(
                    ''
                  );
                }
              })}
            </tbody>
          );
        })}
        </table>
        </div>
      :
      ''
    }

    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={self.closeModalAlert}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
</div>
    );
  }
}

export default ScheduleGradesEdit;



// WEBPACK FOOTER //
// ./src/Components/ScheduleGrades/ScheduleGradesEdit.js